/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

export enum SortBy {
	Date = 'date',
	Role = 'role',
	Location = 'location',
}
